
import { fadeIn } from './app.js'
import { fadeOut } from './app.js'

// --- Popup ---

// Open popup
document.querySelectorAll('.gallery .popup-open').forEach(function(node) {
  node.addEventListener('click', function(e) {
    let myId = node.dataset.id
    fadeIn(node.closest('.content--gallery').querySelector('.popup-wrapper[data-id="'+myId+'"]'))
    document.querySelector('body').classList.add('nooverflow')
  })
})

// Close popup
document.querySelectorAll('.popup-close, .popup-overlay').forEach(function(node) {
  node.addEventListener('click', function(e) {
    fadeOut(node.closest('.popup-wrapper'))
    document.querySelector('body').classList.remove('nooverflow')
  })
})
